import { useContext } from "react"
import CategoryResetContext from "../CategoryResetContext"

const useCategoryResetContext = () => {
  const providedValue = useContext(CategoryResetContext)

  return { ...providedValue }
}

export default useCategoryResetContext
